import ExchangeService from "./service";

export * from "./reqres";

export default ExchangeService;
